@if (data(); as msg) {
    <room-item 
        class="d-inline-block me-2"
        [room]="msg.room"  />
    <span>not found.</span>
}
 